export default "__VITE_ASSET__c7f72fc2__"